import { IconTrash as TablerIconTrash } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconTrash = /*#__PURE__*/ createOutlineIcon(TablerIconTrash, 'IconTrash');
